import React, { useState, useEffect } from 'react';
import getFacility from '../../shared/api/getFacility';
import Layout from '../../shared/components/Layout';
import Header from '@/features/facility/welcome/components/Header';
import Footer from '@/features/facility/welcome/components/Footer';
import PolicyPolicyMain from '../components/PolicyPolicyMain';

const PrivacyPolicy = () => {
  const [isFirstLogin, setisFirstLogin] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        const response = await getFacility();
        setisFirstLogin(response.data.facility.isFirstLogin);
      } catch {
        console.error("failed fetch facility")
      }
    };

    fetchFacility();
  }, []);

  if (isFirstLogin === null) {
    return <></>;
  }

  const member = (
    <Layout>
      <PolicyPolicyMain name="for_facility" />
    </Layout>
  );

  const other = (
    <React.Fragment>
      <Header />
      <PolicyPolicyMain name="for_comprehensive" />
      <Footer />
    </React.Fragment>
  )

  return (
    <React.Fragment>
      { isFirstLogin ? other : member }
    </React.Fragment>
  );
};

export default PrivacyPolicy;
